import { useState } from "react";
import { FaLock, FaUser, FaGoogle, FaMicrosoft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify"; // npm install react-toastify
import "react-toastify/dist/ReactToastify.css";

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Please enter both email and password.");
      return;
    }

    // Simulate login success
    toast.success("Login successful!");
    setTimeout(() => navigate("/dashboard"), 1500); // Replace with actual route
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2">
      {/* LEFT */}
      <div className="bg-gradient-to-br from-[#055862] to-[#ff7a00] text-white flex flex-col justify-center items-center p-10">
        <h2 className="text-3xl font-bold mb-2 text-center">Welcome to iDisKover</h2>
        <p className="text-white/80 max-w-md text-center mb-8">
          Your gateway to intelligent academic search and curated digital content.
        </p>
        <img src="/login.png" alt="Login Art" className="w-40 max-w-md rounded-xl shadow-xl" />
      </div>

      {/* RIGHT */}
      <div className="flex justify-center items-center p-8">
        <form
          onSubmit={handleLogin}
          className="w-full max-w-md bg-white shadow-xl rounded-xl p-8 space-y-6"
        >
          <h3 className="text-2xl font-bold text-[#055862] mb-2 text-center">Login to Your Account</h3>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email address</label>
            <div className="flex items-center border border-gray-300 rounded-md px-3 py-2">
              <FaUser className="text-gray-400 mr-2" />
              <input
                type="email"
                required
                placeholder="you@example.com"
                className="w-full outline-none"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <div className="flex items-center border border-gray-300 rounded-md px-3 py-2">
              <FaLock className="text-gray-400 mr-2" />
              <input
                type="password"
                required
                placeholder="••••••••"
                className="w-full outline-none"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="text-right mt-2 text-sm">
              <a href="/forgot-password" className="text-[#ff7a00] hover:underline">Forgot Password?</a>
            </div>
          </div>

{/*        
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-[#055862] to-[#ff7a00] text-white py-2 rounded-md font-medium hover:opacity-90 transition"
          >
            Login
          </button>
*/}

        <a
        href="/dashboard"
        className="block text-center w-full bg-gradient-to-r from-[#055862] to-[#ff7a00] text-white py-2 rounded-md font-medium hover:opacity-90 transition"
        >
        Login
        </a>
        
          {/* OR */}
          <div className="text-center text-gray-400 text-sm">OR</div>

          {/* OAuth Buttons */}
          <div className="flex flex-col gap-3">
            <button type="button" className="flex items-center justify-center gap-3 border border-gray-300 py-2 rounded-md hover:bg-gray-50 transition">
              <FaGoogle className="text-red-500" />
              <span>Sign in with Google</span>
            </button>
            <button type="button" className="flex items-center justify-center gap-3 border border-gray-300 py-2 rounded-md hover:bg-gray-50 transition">
              <FaMicrosoft className="text-blue-600" />
              <span>Sign in with Microsoft</span>
            </button>
          </div>

          <div className="text-sm text-center text-gray-500 mt-4">
            Don't have an account?{" "}
            <a href="/signup" className="text-[#ff7a00] hover:underline">Sign up</a>
          </div>
        </form>
      </div>
    </div>
  );
}
